<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Интервал" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />

        <autocomplete-multiple name="Тип звонка" :items="callDirections" :select.sync="filter.callDirections" textOverflow>
          <template v-slot:itemIcon="{item}">
            <v-icon small class="mr-1" style="margin-top:-3px">{{item.icon}}</v-icon>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-icon small class="mr-1" style="margin-top:-2px">{{item.icon}}</v-icon> {{item.name}}
          </template>
        </autocomplete-multiple>


        <autocomplete-multiple name="Статус" :items="statuses" :select.sync="filter.statuses" textOverflow>
          <template v-slot:itemIcon="{item}">
            <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-3px"/>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.name}}
          </template>
        </autocomplete-multiple>

        <autocomplete-multiple name="Администратор" :items="adminsFiltered" :select.sync="filter.admins">
            <template v-slot:itemInfo="{item}">
              {{$tools.userFullName(item)}}
            </template>
            <template v-slot:selectedInfo="{item}">
              {{$tools.userFullName(item, true)}} 
            </template>     
        </autocomplete-multiple>

        <text-field name="Номер телефона" :value.sync="filter.phone"/>

        <autocomplete-multiple name="Цель звонка" :items="callTargets" :select.sync="filter.callTarget" textOverflow selectAllEnabled/>

        <autocomplete-single name="Результат звонка" :items="callResults" :select.sync="filter.callResult" clearable>
          <template v-slot:no-data>
            <div class="caption text-center">Не найдено</div>
          </template>
          <template v-slot:itemIcon="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
          </template>
          <template v-slot:selectedInfo="{item}">
            <v-avatar v-if="item.type==='success'" color="success" size="16" style="margin-top:-10px" class="mr-2"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
            <v-avatar v-else-if="item.type==='info'" color="blue" size="16" style="margin-top:-2px"  class="mr-2"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
            <v-avatar v-else color="red" size="16" class="mr-2"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
            <span class="text-no-wrap">{{item.name}}</span>
          </template>
        </autocomplete-single>

      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Группы звонков"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', value: 'id', class:'text-no-wrap'},
            { text: 'Дата и время', value: 'createTime', class:'text-no-wrap' },
            { text: 'Тип звонка', value: 'callDirection', class:'text-no-wrap'},
            { text: 'Статус', value: 'status', class:'text-no-wrap'},
            { text: 'Клиент', value: 'userClient', class:'text-no-wrap'},
            { text: 'Кто', value: 'fromPhoneNumber', class:'text-no-wrap'},
            { text: 'Кому', value: 'toPhoneNumber', class:'text-no-wrap'},
            { text: 'Цель', value: 'callTarget', class:'text-no-wrap'},
            { text: 'Результат', value: 'callResult',  class:'text-no-wrap' },
            { text: 'Длит.: меню / дозвон / разговор', class:'text-no-wrap', sortable:false},
          ]"
          table-class="table9"
      >

        <template v-slot:item="{item}">
          <tr class="_call-log-item" @click="callGroup = item" :key="'cg_'+item.id">
            <td>
              {{item.id}}
            </td>
            <td>{{$tools.dateTimeFormat(item.createTime,'DD.MM.YYYY HH:mm')}}</td>
            <td>
              <call-direction :call-group="item" widget/>
            </td>
            <td>
              <call-group-state :call-group="item" class="d-inline-block"/>
              <tooltip v-if="!$tools.isEmpty(item.comment)" bottom>
                <template v-slot:default><v-icon small class="ml-2">mdi-comment-text-outline</v-icon></template>
                <template v-slot:content>
                  {{item.comment}}
                </template>
              </tooltip>
            </td>
            <td>
              <div v-if="item.userClient===null">
                <div v-if="item.userClientState==='first'">Анон.первичный</div>
                <!-- <div v-else-if="item.userClientState==='second'">Анон.вторичный</div> -->
              </div>
              <div v-else>
                <UserFullName :user="item.userClient"/>
              </div>
            </td>
            <td>
              <call-phone :phone="item.fromPhoneNumber"/>
            </td>
            <td>
              <call-phone :phone="item.toPhoneNumber"/>
            </td>
            <td>
              <div v-if="item.callTarget!==null">{{item.callTarget.name}}</div>
            </td>
            <td>
              <div v-if="item.callResult!==null">
                <v-avatar v-if="item.callResult.type==='success'" color="success" size="16" style="margin-top:-2px"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
                <v-avatar v-else-if="item.callResult.type==='info'" color="blue" size="16" style="margin-top:-2px"><v-icon color="white" size="20">mdi-information-symbol</v-icon></v-avatar>
                <v-avatar v-else color="red" size="16" style="margin-top:-2px"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
                {{item.callResult.name}}
              </div>
            </td>
            <td>
              <call-record-player :callGroup="item"/>
              {{$tools.isEmpty(item.forwardDuration) ? '-' : $tools.secondsToTime(item.forwardDuration)}} /
              {{$tools.isEmpty(item.talkWaitDuration) ? '-' : $tools.secondsToTime(item.talkWaitDuration)}} /
              {{$tools.isEmpty(item.talkDuration) ? '-' : $tools.secondsToTime(item.talkDuration)}}
            </td>
          </tr>
        </template>
      </n-table-view>
      <call-group-detail :callGroup.sync="callGroup" :call-targets="callTargets" @change="$refs.table.load()" />
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import NTableView from "@/componentsV2/base/NTableView.vue";
import LayoutView from "@/components/LayoutView.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";

import {
  Entity_User,
  Entity_UserProfile,
  Entity_CallGroup, Entity_CallEntry, Entity_CallResult, Entity_CallTarget, Entity_CallEntryState
} from "../../../../EntityStoreCacheService";
import CallDirection from "@/views/ContactCenter/Call/CallDirection.vue";
import CallGroupState from "@/views/ContactCenter/Call/CallGroupState.vue";
import moment from "moment";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import CallPhone from "@/components/CallPhone.vue";
import CallGroupDetail from "@/views/ContactCenter/Call/CallGroupDetail.vue";
import CallRecordPlayer from "@/views/ContactCenter/Call/CallRecordPlayer.vue";


export default {
  components: {
    CallRecordPlayer,
    CallGroupDetail,
    CallPhone,
    Tooltip,
    CallGroupState,
    CallDirection,
    NTableView,
    LayoutView,
    DateInterval,
    AutocompleteMultiple,
    AutocompleteSingle,
    TextField,
    UserFullName
  },
  props: ['userId','userPhone'],
  data:()=>({
    loadState: new State(),
    callGroup: null,
    filter:{
      dateFrom:moment().subtract(31, 'days').format('DD.MM.YYYY'),
      dateTo:moment().format('DD.MM.YYYY'),
      callDirections: [],
      statuses: [],
      phone: null,
      callTarget: null,
      callResult: null,
      userClientState: [],
      admins: []
    },
    callTargets: [],
    callResults: [],
    indicators: {},
    admins: [],
    adminsFiltered: [],
    callDirections:[
      {name:'Внутренний',id:0,icon:'mdi-phone-incoming-outgoing'},
      {name:'Входящий',id:1, icon: 'mdi-phone-incoming'},
      {name:'Исходящий',id:2, icon: 'mdi-phone-outgoing'},
    ],
    statuses: [
      {name:'В процессе',id:'progress', color:'#428eda'},
      {name:'Успешно',id:'success', color:'#02924d'},
      {name:'Не отвечено',id:'fail', color:'#F44336'},
      {name:'Не отвечено в нерабочее время',id:'failNonWork', color:'#607D8B'},
    ],
  }),
  watch: {
    filter: {
      handler() {
        this.$tools.debounce(()=>{
          this.$refs.table.load();
        }, 500, 'callGroups')
      },
      deep: true,
    },
  },
  mounted() {
    new Entity_CallTarget()
        .selects(Entity_CallTarget.id)
        .selects(Entity_CallTarget.name)
        .selects(Entity_CallTarget.comment)
        .selects([Entity_CallTarget.callResults, Entity_CallResult.id].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.name].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.type].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.comment].join('.'))
        .order(Entity_CallTarget.sort, true)
        .order([Entity_CallTarget.callResults, Entity_CallResult.sort].join('.'), true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callTargets = v.items;
        })
        .request()
    new Entity_CallResult()
        .selects(Entity_CallResult.id)
        .selects(Entity_CallResult.name)
        .selects(Entity_CallResult.type)
        .selects(Entity_CallResult.comment)
        .selects([Entity_CallResult.callTargets, Entity_CallTarget.id].join('.'))
        .order(Entity_CallResult.type, true)
        .order(Entity_CallResult.sort, true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callResults = v.items;
        })
        .request()
    this.adminsLoad();
  },
  methods:{
    adminsLoad(){
      let rb = new Entity_User()
      .selects(Entity_User.id)
      .selects(Entity_User.firstName)
      .selects(Entity_User.lastName)
      .selects(Entity_User.secondName)
      .selects(Entity_User.imageUrl)
      .selects(Entity_User.type)

      rb.filterAnd([Entity_User.entity, Entity_User.type].join('.')+' =?','admin');

      rb.page(1).onPage(10000);


      rb.request((data)=>{
        this.admins = data.items
      }, (e)=>{
        console.error(e.response.data.message);
      })
    },
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_CallGroup()
          .selects(Entity_CallGroup.id)
          .selects(Entity_CallGroup.callDirection)
          .selects(Entity_CallGroup.status)
          .selects(Entity_CallGroup.disconnectReasonMessage)
          .selects(Entity_CallGroup.createTime)
          .selects(Entity_CallGroup.forwardDuration)
          .selects(Entity_CallGroup.talkWaitDuration)
          .selects(Entity_CallGroup.talkDuration)
          .selects(Entity_CallGroup.comment)
          .selects(Entity_CallGroup.fromPhoneNumber)
          .selects(Entity_CallGroup.toPhoneNumber)
          .selects(Entity_CallGroup.callRecordFile)

          .selects([Entity_CallGroup.callTarget, Entity_CallTarget.id].join('.'))
          .selects([Entity_CallGroup.callTarget, Entity_CallTarget.name].join('.'))
          .selects([Entity_CallGroup.callTarget, Entity_CallTarget.comment].join('.'))

          .selects([Entity_CallGroup.callResult, Entity_CallResult.id].join('.'))
          .selects([Entity_CallGroup.callResult, Entity_CallResult.name].join('.'))
          .selects([Entity_CallGroup.callResult, Entity_CallResult.type].join('.'))
          .selects([Entity_CallGroup.callResult, Entity_CallResult.comment].join('.'))

          .selects([Entity_CallGroup.userFrom, Entity_User.id].join('.'))
          .selects([Entity_CallGroup.userFrom, Entity_User.type].join('.'))
          .selects([Entity_CallGroup.userFrom, Entity_User.firstName].join('.'))
          .selects([Entity_CallGroup.userFrom, Entity_User.lastName].join('.'))
          .selects([Entity_CallGroup.userFrom, Entity_User.secondName].join('.'))

          .selects([Entity_CallGroup.userTo, Entity_User.id].join('.'))
          .selects([Entity_CallGroup.userTo, Entity_User.type].join('.'))
          .selects([Entity_CallGroup.userTo, Entity_User.firstName].join('.'))
          .selects([Entity_CallGroup.userTo, Entity_User.lastName].join('.'))
          .selects([Entity_CallGroup.userTo, Entity_User.secondName].join('.'))

          .selects(Entity_CallGroup.userClientState)
          .selects([Entity_CallGroup.userClient, Entity_User.id].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.type].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.firstName].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.lastName].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.secondName].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
          .selects([Entity_CallGroup.userClient, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))

          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.state].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.fromPhoneNumber].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.toPhoneNumber].join('.'))

          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userFrom, Entity_User.id].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userFrom, Entity_User.type].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userFrom, Entity_User.firstName].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userFrom, Entity_User.lastName].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userFrom, Entity_User.secondName].join('.'))

          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userTo, Entity_User.id].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userTo, Entity_User.type].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userTo, Entity_User.firstName].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userTo, Entity_User.lastName].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.userTo, Entity_User.secondName].join('.'))

          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.callEntryStates, Entity_CallEntryState.state].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.callEntryStates, Entity_CallEntryState.seq].join('.'))
          .selects([Entity_CallGroup.callEntrys, Entity_CallEntry.callEntryStates, Entity_CallEntryState.timestamp].join('.'))

          .collect(Entity_CallGroup.collect_indicators)

      rb.page(page).onPage(onPage)

      if(this.filter.dateFrom)
        rb.filterAnd([Entity_CallGroup.entity, Entity_CallGroup.createTime].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      if(this.filter.dateTo)
        rb.filterAnd([Entity_CallGroup.entity, Entity_CallGroup.createTime].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
      if (this.filter.callDirections.length>0)
        rb.filterAnd([Entity_CallGroup.entity, Entity_CallGroup.callDirection].join('.')+' in (?)', this.queryArray(this.filter.callDirections))

      if(this.filter.statuses.length>0){
        let params = [];
        this.filter.statuses.forEach(v=>{
            params.push(v.id);
        })
        rb.filterAnd([Entity_CallGroup.entity,Entity_CallGroup.status].join('.')+" in (?)", params.join(','));
      }


      if (this.filter.phone)
        rb.filterAnd([Entity_CallGroup.entity,Entity_CallGroup.fromPhoneNumber].join('.')+' LIKE ? OR '+[Entity_CallGroup.entity,Entity_CallGroup.toPhoneNumber].join('.')+' LIKE ?', '%'+this.filter.phone+'%', '%'+this.filter.phone+'%');

      if(this.filter.admins.length>0){
        let admins = [];
        this.filter.admins.forEach(v=>{
          admins.push(v.id)
        })

        rb.filterAnd(
            [Entity_CallGroup.entity,Entity_CallGroup.userClient,Entity_User.id].join('.')+' in (?)'
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.userFrom, Entity_User.id].join('.')+' in (?)'
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.userTo, Entity_User.id].join('.')+' in (?)'
            , admins.join(','), admins.join(','), admins.join(',')
        );
      }

      //filter by current user
      rb.filterAnd(
            [Entity_CallGroup.entity,Entity_CallGroup.userClient,Entity_User.id].join('.')+' =?'
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.userFrom, Entity_User.id].join('.')+' =?'
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.userTo, Entity_User.id].join('.')+' =?'
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.fromPhoneNumber].join('.')+' LIKE ?' //fix for anon user
            +' OR '+[Entity_CallGroup.entity,Entity_CallGroup.toPhoneNumber].join('.')+' LIKE ?'
            , this.userId, this.userId, this.userId, '%'+this.userPhone+'%', '%'+this.userPhone+'%'
      );

      if(this.filter.callTarget!==null&&this.filter.callTarget.length>0)
        rb.filterAnd([Entity_CallGroup.entity, Entity_CallGroup.callTarget, Entity_CallTarget.id].join('.')+' in (?)', this.queryArray(this.filter.callTarget))
      if(this.filter.callResult)
        rb.filterAnd([Entity_CallGroup.entity, Entity_CallGroup.callResult, Entity_CallResult.id].join('.')+'=?', this.filter.callResult.id)


      rb.addStateCallback((v)=>{
        this.loadState.setRequestBuilderState(v)
        if(v.success) {
          this.indicators = v.collect.indicators

          this.adminsFiltered = this.admins.filter(a=>this.indicators.adminIds.includes(a.id));
        }
      })  

      sortFields.forEach(v=>{
        rb.order(v.field, v.isAsc)
      })

      return rb;
    },
    queryArray(items,key='id') {
      let arr = [];
      items.forEach(s=>{
        arr.push(s[key]);
      });
      return arr;
    },
  }
}
</script>